import api from "~/api/api.js";

export interface ProductItemPrice {
    retailPrice: number;
    oldPrice: number | null;
    purchasePrice: number | null;
}

export interface ProductItemAttribute {
    id: number;
    name: string;
    slug: string;
}

export interface ProductItemAttributeValue {
    id: number;
    value: string;
}

export interface ProductItemInterface {
    id: number;
    productId: number;
    attribute: ProductItemAttribute | null;
    attributeValue: ProductItemAttributeValue | null;
    barcode: string | null;
    internalArticle: string | null;
    price: ProductItemPrice | null;
    stock: number;
}

// SKU-слой (карточка 06 модели "продукт → items"): цена/остаток уже
// встроены в ответ /product-items — отдельных запросов к /prices и
// /warehouse-stocks на витрине не нужно.
export class ProductItem {

    static async getByProduct(productId: number): Promise<ProductItemInterface[]> {
        const data = await api("/product-items/index", {productId});
        return data.items ?? [];
    }

}
